export type Lang = 'fr' | 'en';

export const translations = {
  en: {
    subtitle: 'Front-End Developer',
    menu: {
      home: 'Home',
      info: 'Info',
      projects: 'Projects',
      contact: 'Contact',
    },
    home: {
      p1: '**Front-end developer** based in **Paris**, specialized in **React**, with **three years of experience** working for Ouihelp, including **two years in alternating internships** and **one year as a full-time employee**.',
      p2: 'During my time at **Ouihelp**, I had the opportunity to work on **several exciting projects**, which allowed me **to develop my front-end and back-end skills** as part of a team.',
      p3: "I obtained my **Bachelor's degree** in **Web Development from HETIC** after completing a **BTS SIO**. In addition to my work, I enjoy staying **up-to-date on the latest trends and technologies** in web development.",
    },
    info: {
      careerCounselor: 'Career Counselor',
      softwareEngineer: 'Software Engineer',
      trainee: 'Trainee back developer',
      stackFront: 'Stack Front',
      stackBack: 'Stack Back',
    },
    project: {
      business: 'Business Project',
      school: 'School Project',
    },
    theme: {
      light: 'LIGHT',
      dark: 'DARK',
    },
    color: 'COLOR',
  },
  fr: {
    subtitle: 'Développeur Front-End',
    menu: {
      home: 'Accueil',
      info: 'Info',
      projects: 'Projets',
      contact: 'Contact',
    },
    home: {
      p1: "**Développeur front-end** basé à **Paris**, spécialisé en **React**, avec **trois ans d'expérience** chez Ouihelp, dont **deux ans en alternance** et **un an en tant que salarié**.",
      p2: "Pendant mon séjour chez **Ouihelp**, j'ai eu l'occasion de travailler sur **plusieurs projets passionnants**, ce qui m'a permis **de développer mes compétences front-end et back-end** au sein d'une équipe.",
      p3: "J'ai obtenu mon **Bachelor** en **Développement Web à l'HETIC** après un **BTS SIO**. En dehors du travail, j'aime rester **à jour sur les dernières tendances et technologies** du développement web.",
    },
    info: {
      careerCounselor: 'Conseiller emploi',
      softwareEngineer: 'Ingénieur logiciel',
      trainee: 'Développeur back en stage',
      stackFront: 'Stack Front',
      stackBack: 'Stack Back',
    },
    project: {
      business: 'Projets professionnels',
      school: 'Projets scolaires',
    },
    theme: {
      light: 'CLAIR',
      dark: 'SOMBRE',
    },
    color: 'COULEUR',
  },
};
